import { render, staticRenderFns } from "./QuickLinkTable.vue?vue&type=template&id=31b2009c&scoped=true"
import script from "./QuickLinkTable.vue?vue&type=script&lang=js"
export * from "./QuickLinkTable.vue?vue&type=script&lang=js"
import style0 from "./QuickLinkTable.vue?vue&type=style&index=0&id=31b2009c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b2009c",
  null
  
)

export default component.exports